"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionDown = function AccordionDown() {
  return _react2.default.createElement(
    "g",
    { id: "arrow-down" },
    _react2.default.createElement("polygon", { id: "Shape", points: "441.47 96 250.01 287.48 58.53 96 0 154.53 250.01 404.54 500 154.53" })
  );
};

exports.default = AccordionDown;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/AccordionDown.js
// module id = 2915
// module chunks = 4